<div class="chat-container">
    <img src="../../../../../assets/projects/Backstage/e31b752875679b64fce009922f9f0dda.gif" width="80%">
</div>